import { H3HexagonLayer } from "@deck.gl/geo-layers";
import * as chromatic from "d3-scale-chromatic";
import { scaleSequential } from "d3-scale";

import { extent } from "d3-array";

import { color } from "d3-color";

import { prop, values } from "ramda";

const ALPHA = 60;
const ALPHA_VALUE = 255 * (ALPHA / 100);

export function getStateHexagonLayer({ data, layerId = "hexagon-layer" }) {
  const dataAccessor = (d) => {
    return d?.count;
  };

  const dataExtent = extent(values(data), dataAccessor);

  const colorScale = scaleSequential((t) =>
    chromatic.interpolateRdYlGn(1 - t)
  ).domain(dataExtent);

  const layerProps = {
    data: data,
    extruded: false, // No elevation
    stroked: false,
    filled: true,
    getHexagon: prop("hex"),
    coverage: 0.99,
    getFillColor: (d) => {
      const count = dataAccessor(d);
      const colorString = colorScale(count);

      if (colorString != null) {
        const colorInstance = color(colorString);
        return [colorInstance.r, colorInstance.g, colorInstance.b, ALPHA_VALUE];
      } else {
        return [0, 0, 0, 0];
      }
    },
  };

  return { layers: [new H3HexagonLayer(layerProps)], colorScale };
}
